var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgramacao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.854 26.5396H34.1461V53.1419H25.854V26.5396Z",
    fill: "#E0E0E0",
    stroke: "#333333",
    strokeWidth: 4.305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5843 58.2907H13.4158L13.7947 56.8302C14.1978 55.2794 15.0837 53.9095 16.3151 52.9324C17.5466 51.9554 19.055 51.4258 20.6067 51.4256H39.3925C40.9443 51.4256 42.4528 51.9552 43.6843 52.9323C44.9158 53.9093 45.8016 55.2793 46.2045 56.8302L46.5843 58.2907Z",
    fill: "#E0E0E0",
    stroke: "#333333",
    strokeWidth: 4.305,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M31.6584 26.5396V58.2907H46.5843L46.2053 56.8302C45.8023 55.2794 44.9164 53.9095 43.6849 52.9324C42.4535 51.9554 40.9451 51.4258 39.3933 51.4256H34.1461V26.5396H31.6584Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 4.305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3232 39.4116H5.67658C5.16834 39.4118 4.66506 39.3082 4.19549 39.107C3.72592 38.9058 3.29926 38.6108 2.93988 38.2389C2.5805 37.867 2.29544 37.4254 2.101 36.9395C1.90656 36.4535 1.80653 35.9327 1.80664 35.4067V5.65844C1.80653 5.13247 1.90656 4.61164 2.101 4.12568C2.29544 3.63973 2.5805 3.19819 2.93988 2.82627C3.29926 2.45436 3.72592 2.15936 4.19549 1.95813C4.66506 1.7569 5.16834 1.65339 5.67658 1.6535H54.324C54.8322 1.6535 55.3354 1.7571 55.8049 1.95838C56.2744 2.15966 56.7009 2.45467 57.0602 2.82657C57.4195 3.19848 57.7045 3.63999 57.8989 4.12588C58.0933 4.61178 58.1933 5.13255 58.1932 5.65844V35.4076C58.1932 35.9335 58.0931 36.4542 57.8986 36.9401C57.7041 37.4259 57.419 37.8674 57.0596 38.2392C56.7003 38.611 56.2736 38.9059 55.8041 39.1071C55.3346 39.3083 54.8314 39.4118 54.3232 39.4116Z",
    fill: "#666666",
    stroke: "#333333",
    strokeWidth: 4.305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.95288 11.2003V8.23201C5.9531 7.62517 6.1862 7.04326 6.60091 6.61424C7.01563 6.18522 7.57801 5.94421 8.16439 5.94421H9.26973",
    stroke: "white",
    strokeWidth: 4.305,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.95288 16.8855V15.9201",
    stroke: "white",
    strokeWidth: 4.305,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3542 9.91309L44.5941 20.5326L38.3542 31.152",
    stroke: "white",
    strokeWidth: 4.305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6456 31.152L15.4058 20.5326L21.6456 9.91309",
    stroke: "white",
    strokeWidth: 4.305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9867 6.37326L26.0129 34.6919",
    stroke: "white",
    strokeWidth: 4.305,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.3233 1.6535H44.124L33.7754 39.4116H54.3225C54.8307 39.4118 55.3341 39.3082 55.8037 39.107C56.2733 38.9058 56.7 38.6108 57.0595 38.2389C57.4189 37.867 57.704 37.4255 57.8986 36.9395C58.0931 36.4536 58.1932 35.9327 58.1932 35.4067V5.65844C58.1933 5.13247 58.0933 4.61164 57.8989 4.12568C57.7044 3.63973 57.4194 3.19819 57.06 2.82627C56.7006 2.45436 56.274 2.15936 55.8044 1.95813C55.3348 1.7569 54.8315 1.65339 54.3233 1.6535Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 4.305,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramacao);
export default __webpack_public_path__ + "static/media/programacao.f9f79d5e1b8003ca7b255cf09768c197.svg";
export { ForwardRef as ReactComponent };